import script from "./CheckDetailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckDetailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CheckDetailDialog.vue?vue&type=style&index=0&id=b98336a8&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b98336a8"]])

export default __exports__